import React, {Fragment, useEffect, useState} from 'react';
import parse from "html-react-parser";
import {mrbgStore, setSettingsForm} from './mrbgRedux';
import {mrbgTools} from '../../mrbgLib/mrbgTools.js'
import mrbgS2S from '../../mrbgLib/mrbgS2S.js';
import MrbgScrollFrame from './MrbgScrollFrame.jsx';
import MrbgCheckBox from './MrbgCheckBox.jsx';

function MrbgTable({formID,tblID,columns,rowsCol,pencil,trash,view,unSortable,checkbox,origin,think,multiRow,component,filterMode,formStyle}){

  const
    tblMaxRows = 40,
    [tblInfo,setTblInfo] = useState(mrbgStore.getState().mrbgVars[tblID]),
    [tblCookieObj,setTblCookieObj] = useState(()=>{
      if( !unSortable ){
        try{ return JSON.parse(mrbgTools.cookie.get(tblID)) }
        catch{return {}}
      }
      return false;
    }),
    storeKey = tblID.substring(0,tblID.length-1)+'T';

  if( !tblInfo )
    console.log(formID,tblInfo)

  const
    [startRC,lengthRC,foundRC] = Object.values( mrbgStore.getState().mrbgVars[storeKey] );

  function changeSort( e, val ){
    var newObj = JSON.parse(JSON.stringify(tblCookieObj)) || {};
    if( e.ctrlKey ){
      var dir =
        typeof newObj.orderBy==='object' && Object.hasOwn(tblCookieObj.orderBy,val) && newObj.orderBy[val]==='DESC'?
          'ASC':
          'DESC';
      delete newObj.orderBy[val];
      newObj.orderBy[val] = dir;
    }
    else{
      newObj.orderBy =
        typeof newObj.orderBy==='object' && Object.hasOwn(newObj.orderBy, val) && newObj.orderBy[val]==='ASC'?
          {[val]:'DESC'}:
          {[val]:'ASC' };
    }

    setTblCookieObj( newObj );
  }

  useEffect( () => {

    if( mrbgTools.cookie.get(tblID)===JSON.stringify(tblCookieObj))
      return;

    mrbgTools.cookie.set( tblID,JSON.stringify(tblCookieObj),30 );
    let MD;
    if( filterMode ){
      var curForm = document.getElementByDataID(formID);
      MD = new FormData(curForm);
    }
    else
      MD = new FormData();

    MD.append('tblID',tblID);
    var mti = document.querySelectorAll('#'+formID+' input[type=hidden][data-role=mrbgTblIndicator]');
    mti.forEach(hidInput=>{
      MD.append(hidInput.getAttribute('name'),hidInput.value);
    });
    MD.append('start',Math.floor(startRC/tblMaxRows))

    mrbgS2S(formID,MD,'mRe',origin);
  }, [tblCookieObj] );
  useEffect(()=>{
    const unsubscribe = mrbgStore.subscribe(()=>{
      setTblInfo(mrbgStore.getState().mrbgVars[tblID])
    });
    return () =>unsubscribe();
  },[]);

  return(
    <>
      <MrbgScrollFrame properties={{className:formStyle.tableFrame}}>
        <table id={tblID} className={formStyle.mrbgTable}>
          <ThRow {...{columns,think,rowsCol,pencil,trash,view,checkbox,tblCookieObj,changeSort,formStyle}} />
          <TdRow {...{formID,tblInfo,columns,think,rowsCol,checkbox,pencil,trash,view,startRC,multiRow,component,origin,formStyle}} />
        </table>
      </MrbgScrollFrame>
      {
        startRC && lengthRC?
          <MT_moreResult {...{startRC,foundRC,tblMaxRows,tblCookieObj,setTblCookieObj,formStyle}}/>:
          ''
      }
    </>
  )
}
function ThRow({columns,think,rowsCol,pencil,trash,view,checkbox,tblCookieObj,changeSort,formStyle}){

  var
    colKey = Object.keys(columns),
    len = colKey.length,
    isMultiple = false,
    rowSpan = {},
    lang = document.documentElement.getAttribute('lang');

  for( let i=0; i<len; i++ )
    if( columns[colKey[i]] instanceof Object ){
      isMultiple = true;
      rowSpan = {rowSpan:2}
      break;
    }

  return(
    <thead>
      <tr>
        { rowsCol ? <ThRowCntCol {...{rowSpan,tblCookieObj,changeSort,formStyle}}/>: '' }
        { checkbox? <th className={formStyle.think} {...rowSpan}>{lang==='fa'? 'انتخاب':'choice'}</th>: ''}
        { pencil  ? <th className={formStyle.think} {...rowSpan}>{lang==='fa'? 'ویرایش':'edit'}</th>: ''}
        { trash   ? <th className={formStyle.think} {...rowSpan}>{lang==='fa'? 'حذف':'delete'}</th>: ''}
        { view    ? <th className={formStyle.think} {...rowSpan}>{lang==='fa'? 'جزئیات':'delete'}</th>: ''}
        {
          colKey.map((k,ind)=>{
            if( columns[k] instanceof Object ){
              return <th colSpan={Object.keys(columns[k]).length} key={ind}>{parse(mrbgTools.toHtml.text(k,formStyle))}</th>
            }
            else
              return <ThRowOtherCols {...{th:columns[k],td:k,think,rowSpan,changeSort,tblCookieObj,formStyle}} key={ind} />
          })
        }
      </tr>
      {
        isMultiple?
          <tr>
            {
              colKey.map(k=>{
                if( columns[k] instanceof Object )
                  return(
                    Object.keys(columns[k]).map((subK,ind)=>{
                      return <ThRowOtherCols {...{th:columns[k][subK],td:subK,think,rowSpan,changeSort,tblCookieObj,formStyle}} key={ind} />
                    })
                  )
              })
            }
          </tr>:
          ''
      }
    </thead>
  )
}
function ThRowCntCol({rowSpan,tblCookieObj,changeSort,formStyle}){

  var
    lang = document.documentElement.getAttribute('lang'),
    icon =
      typeof tblCookieObj?.orderBy==='object' && Object.hasOwn(tblCookieObj.orderBy, 'id')?
        <i className={`fa-regular fa-sort-alpha-${tblCookieObj.orderBy.id.toLowerCase()}`}></i>:
        '';

  return(
    <th className={formStyle.think} {...rowSpan} onClick={e=>changeSort(e,'id')}>
      <label>
        {lang=='fa'? 'ردیف':'row'}
        {icon}
      </label>
    </th>
  )
}
function ThRowOtherCols({th,td,think,rowSpan,tblCookieObj,changeSort,formStyle}){

  var icon =
    typeof tblCookieObj?.orderBy==='object' && Object.hasOwn(tblCookieObj.orderBy, td)?
      <i className={`fa-regular fa-sort-alpha-${tblCookieObj.orderBy[td].toLowerCase()}`}></i>:
      '';

  return(
    <th className={Array.isArray(think) && think.includes(td)? formStyle.think:null} {...rowSpan}  onClick={e=>changeSort(e,td)}>
      <label>
        {parse(mrbgTools.toHtml.text(th,formStyle))}
        {icon}
      </label>
    </th>
  )
}
function TdRow({formID,origin,tblInfo,columns,component,think,multiRow,rowsCol,checkbox,pencil,trash,view,tdClass,startRC,formStyle}){

  function getData(id){
    var MD = new FormData();
    MD.append('id',id);
    mrbgS2S( formID, MD, 'gDt', origin )
  }
  function removeRow(id){
    mrbgStore.dispatch(setSettingsForm({[formID]:{...mrbgStore.getState().formsSettings[formID],msgTxt: ''}}))
    var MD = new FormData();
    MD.append('id',id);
    mrbgS2S( formID, MD, 'dlt', origin )
  }
  function copy(e,text){
    if( !text )
      return false;

    text = text.toString();

    if( text.match(/\d{1,3}(,\d{3})*/) )
      text = text.replaceAll(',','');
    navigator.clipboard.writeText(text);
  }

  var tdKey = [];

  Object.keys(columns).map(k=>{
    tdKey =
      columns[k] instanceof Object?
        [...tdKey, ...Object.keys(columns[k])]:
        [...tdKey, k];
  })

  return(
    <tbody>
      {
        tblInfo.map((rows,k)=>{
          var
            trBg='',
            maxLen= 0,
            tdAttr= {};

          if( multiRow ){
            trBg = ( k%2 )? formStyle.darkTr: formStyle.lightTr;
            maxLen = 0;
            multiRow.map(k1=>{
              if( Array.isArray(rows[k1]) )
                maxLen = Math.max( maxLen, rows[k1].length );
            })
            if( maxLen>1 )
              tdAttr.rowSpan = maxLen;
          }

          return(
            <React.Fragment key={k}>
              <tr className={trBg}>
                {
                  rowsCol?
                    <td className={formStyle.think} {...tdAttr} key="rc">{startRC++}</td>:
                    ''
                }
                {
                  checkbox?
                    <td className={formStyle.think} {...tdAttr} key="cb">
                      <MrbgCheckBox {...{formID,name:`id[${k}]`,index:k,other:{value:rows.id},formStyle}}/>
                    </td>:
                    ''
                }
                {
                  pencil?
                    <td className={formStyle.think} {...tdAttr} key="pn" onClick={()=>getData(rows.id)}>
                      <i className="fa-regular fa-pencil"></i>
                    </td>:
                    ''
                }
                {
                  trash?
                    <td className={formStyle.think} {...tdAttr} key="tr" onClick={()=>removeRow(rows.id)}>
                      <i className="fa-regular fa-trash-can"></i>
                    </td>:
                    ''
                }
                {
                  view?
                    <td className={formStyle.think} {...tdAttr} key="vw">
                      <a href={`/panel/${rows.id}`} target="_blank" className="fa-regular fa-eye"></a>
                    </td>:
                    ''
                }
                {
                  tdKey.map((colName, ind2)=>{
                    var cellClass = [];
                    if( think && think.includes(colName) )
                      cellClass.push(formStyle.think);
                    if( tdClass && Object.hasOwn(tdClass,colName) )
                      cellClass.push(tdClass[colName]);
                    if( component && ['date','dateTime'].includes(component[colName]) )
                      cellClass.push(formStyle.ltrTd);
                    tdAttr = {
                      ...tdAttr,
                      className: cellClass.join(' ')
                    };

                    // IF IS STRING
                    if( !Array.isArray(rows[colName]) )
                      return <TdRowString {...{content:rows[colName], copy, comName:(component && component[colName]) ,tdAttr,formStyle}} key={ind2}/>

                    else{
                      if( multiRow && multiRow.includes(colName) ){
                        let newTdA = {...tdAttr};
                        newTdA.rowSpan = rows[colName].length? maxLen/rows[colName].length: 1;

                        if( Array.isArray(rows[colName][0]) && rows[colName][0].length >1 )
                          return <TdRowArray {...{contentArray:rows[colName][0], comName:(component && component[colName]), tdAttr:newTdA}}  key={ind2}/>
                        else
                          return <TdRowString {...{content:rows[colName][0], copy, comName:(component && component[colName]), tdAttr:newTdA,formStyle}}  key={ind2}/>
                      }
                      else{
                        if( rows[colName].length == 1 )
                          return <TdRowString {...{content:rows[colName][0], copy, comName:(component && component[colName]), tdAttr,formStyle}}  key={ind2}/>
                        else
                          return <TdRowArray {...{contentArray:rows[colName], comName:(component && component[colName]), tdAttr}}  key={ind2}/>
                      }
                    }
                  })
                }
              </tr>
              { maxLen>1? <NextTr {...{rows,copy,rowKey:k,comName:component,maxLen:maxLen,multiRow:multiRow,tdAttr:tdAttr,think,tdClass,component,formStyle}}/>: ''}
            </React.Fragment>
          )
        })
      }
    </tbody>
  )
}
function TdRowString({content,comName,tdAttr,copy,formStyle}){

  tdAttr = {
    ...tdAttr,
    className: tdAttr.className? tdAttr.className+' pointer': 'pointer'
  }

  return(
    <td { ...tdAttr} onDoubleClick={e=>copy(e,content)}>
      { comName? <TblComponent {...{comName,content,formStyle}} />: content }
    </td>
  )
}
function TdRowArray({contentArray,comName,tdAttr,formStyle}){

  return(
    <td {...tdAttr}>
      {
        contentArray.map((v,k)=>{
          return(
            <React.Fragment key={k}>
              { comName? <TblComponent {...{comName,content:v,formStyle}} />: <div>{v}</div> }
            </React.Fragment>
          )
        })
      }
    </td>
  )
}
function TblComponent({comName,content,formStyle}){

  if( content===null )
    return null;

  else if( comName=='balance' ){
    if( content===0 )
      return <i className={`fa-regular fa-check ${formStyle['fa-check']}`}></i>
    else
      return <>{ content>0? <bdi>+ {content}</bdi>: <bdi>- {content}</bdi> }</>
  }

  else if( comName=='bdi' )
    return <bdi>{content}</bdi>

  else if( comName=='date' )
    return mrbgTools.Calendar.m2j(content,'date')

  else if( comName=='dateTime' )
    return mrbgTools.Calendar.m2j(content)

  else if( comName=='bookingStatus' )
    return <BookingStatus {...{content,formStyle}} />

  else if( comName=='htmlContent' )
    return parse( content )

  else if( comName=='icon' ){
    if( content==0 )
      return <i className={`fa-solid fa-close ${formStyle['fa-close']}`}></i>;
    else if( content==1 )
      return <i className={`fa-solid fa-check ${formStyle['fa-check']}`}></i>;
    else
      return <i className={content}></i>
  }

  else if( comName=='img' )
    return <img src={`/img/${content}`}/>

  else if( comName=='link' ){
    if( content instanceof Object && Object.hasOwn(content,'text') && Object.hasOwn(content,'href') ){
      if( content.text instanceof Object && Object.hasOwn(content.text,'component'))
        return <a href={content.href} {...content.attr||{}}>
          <TblComponent {...{comName:Object.keys(content.text.component)[0], content:Object.values(content.text.component)[0], formStyle}} />
        </a>
      else
        return <a href={content.href} {...content.attr||{}}>{content.text}</a>
    }
    else
      return content;
  }

  else if( comName=='phone' ){
    var len = content.length;
    return <a href={`tel:${content}`}>{`${content.substring(0,len-7)} ${content.substring(len-7,len-4)} ${content.substring(len-4,len)}`}</a>
  }

  else if( comName=='mail' ){
    return <a href={`mailto:${content}`}>{`${content.replace('@','[a]')}`}</a>
  }

  else if( comName=='price' )
    return(
      !isNaN(Number(content))?
        content<0?
          <bdi className={formStyle.negativeDigit}>{content.toPrice()}</bdi>:
          <bdi>{content.toPrice()}</bdi>:
        <bdi>{content}</bdi>
    );

  else if( comName=='SetMissedFollow' )
    return <i className="fa-regular fa-comment-dots" onDoubleClick={e=>mrbgTools.myEvent.missedFollow(e,content)}></i>

  else if( comName=='json' )
    return <div>{Object.entries(content)}</div>

  else
    return `${comName} ${content}`
}
function NextTr({rows,rowKey,comName,maxLen,multiRow,tdAttr,copy,think,tdClass,component,formStyle}){

  var nextRowsNum = [];
  for( let i=1; i<maxLen; i++ )
    nextRowsNum.push(i);

  return(
    <>
      {
        nextRowsNum.map(key=>{
          return(
            <tr className={ (rowKey%2)? `${formStyle.darkTr} ${formStyle.ExTrSh}`: `${formStyle.lightTr} ${formStyle.ExTrSh}` } key={key}>
              {
                multiRow.map((colName,k)=>{
                  if( rows[colName] && rows[colName][key]!==undefined ){
                    let newTdA = {...tdAttr};
                    newTdA.rowSpan = maxLen/rows[colName].length;
                    var cellClass = [];
                    if( think?.includes(colName) )
                      cellClass.push(formStyle.think);
                    if( tdClass && Object.hasOwn(tdClass,colName) )
                      cellClass.push(tdClass[colName]);
                    if( component && ['date','dateTime'].includes(component[colName]) )
                      cellClass.push(formStyle.ltrTd);
                    newTdA = {
                      ...newTdA,
                      className: cellClass.join(' ')
                    };

                    return(
                      <React.Fragment key={k}>
                        {
                          // Array.isArray(rows[colName][key])?
                          //   <TdRowArray {...{content:rows[colName][key],copy,comName:(comName && comName[colName]),tdAttr:newTdA}} key={k}/>:
                            <TdRowString {...{content:rows[colName][key],copy,comName:(comName && comName[colName]),tdAttr:newTdA,formStyle}} key={k}/>
                        }
                      </React.Fragment>
                    )
                  }
                })
              }
            </tr>
          )
        })
      }
    </>
  )
}
function MT_moreResult({startRC,foundRC,tblMaxRows,tblCookieObj,setTblCookieObj,formStyle}){

  var btnList = [];
  for( let i=0; i<Math.ceil(foundRC/tblMaxRows); i++ )
    btnList.push(i);

  return(
    <ul className={formStyle.moreResult}>
      {
        btnList.map((i,k)=>{
          return <li className={(Math.floor(startRC/tblMaxRows)==i)? formStyle.activeMoreResult: ''} key={k} onClick={()=>setTblCookieObj({...tblCookieObj,start:i})}>{i+1}</li>
        })
      }
    </ul>
  )
}
function BookingStatus({content,formStyle}){

  var
    attr = {
      'رزرو': ['BS_reserve','fa-timer'],
      'در انتظار پرداخت': ['BS_awaiting','fa-hourglass-half'],
      'فیکس': ['BS_fix','fa-lock'],
      'اکتیو': ['BS_active','fa-unlock'],
      'انجام شد': ['BS_done','fa-lock'],
      'کنسل': ['BS_cancel','fa-close'],
      'پایان': ['BS_finish','fa-power-off']
    };

  return <div className={formStyle[attr[content][0]]}>{content} <i className={`fa-regular ${attr[content][1]}`}></i></div>
}
export default MrbgTable;